import type { Run, RunsStatusBarsProps } from "./RunsStatusBars.types";

export const aggregateRuns = (data: RunsStatusBarsProps["data"]) => {
  if (Array.isArray(data[0])) {
    data = (data as Run[][]).map((item) => ({
      ...item[0],
      last_run: item[0].last_run || item[0].start_time,
      ...(item.length > 1 && {
        runs: item.map((run) => ({
          ...run,
          last_run: run.last_run || run.start_time,
        })),
      }),
    }));
  }

  return data;
};
